// Used for loading state for benefits, articles, products and consumer guides.
export const getPlaceholderList = (count: number = 12) => [...Array(count).keys()];
